// StyledPaper for use inside a popup e.g. filter builder and tags
// provides border background and padding

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const StyledPaper = styled(Paper)(({ theme }) => ({
    // root: should just work here!
    '&.MuiPaper-root': {
        backgroundColor: theme.styled.paper.background,
        backgroundImage: 'none',
        border: 'solid',
        borderColor: theme.styled.paper.border,
        borderWidth: 2,
        padding: 5
    },
}));

export default StyledPaper;
